"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.identifyUser = void 0;
const utils_1 = require("@aws-amplify/core/internals/utils");
const pinpoint_1 = require("@aws-amplify/core/internals/providers/pinpoint");
const errorHelpers_1 = require("../../../errors/errorHelpers");
const utils_2 = require("../../../utils");
const utils_3 = require("../utils");
const identifyUser = async ({ userId, userProfile, options, }) => {
    (0, errorHelpers_1.assertIsInitialized)();
    const { credentials, identityId } = await (0, utils_2.resolveCredentials)();
    const { appId, region } = (0, utils_3.resolveConfig)();
    const { address, optOut, userAttributes } = options ?? {};
    if (!(await (0, pinpoint_1.getEndpointId)(appId, 'PushNotification'))) {
        // if there is no cached endpoint id, wait for successful endpoint creation before continuing
        await (0, utils_3.getInflightDeviceRegistration)();
    }
    await (0, pinpoint_1.updateEndpoint)({
        address,
        channelType: (0, utils_3.getChannelType)(),
        optOut,
        appId,
        category: 'PushNotification',
        credentials,
        identityId,
        region,
        userAttributes,
        userId,
        userProfile,
        userAgentValue: (0, utils_2.getPushNotificationUserAgentString)(utils_1.PushNotificationAction.IdentifyUser),
    });
};
exports.identifyUser = identifyUser;
